<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
      <!-- start of title -->
      <div class="title-box">
          <el-button type="default" size="mini" @click="$router.go(-1)">返回</el-button>
          <span>票据冲红流程</span>
      </div>
      <!-- end of title -->

      <!-- start of form -->
      <div class="form-box">
          <!-- start of 付款申请信息 -->
          <div class="back-color-fff mt-4">
              <span class="form-title">票据冲红流程信息</span>
              <el-form ref="formData">
                  <el-row :gutter="24">
                      <el-col :span="8">
                          <el-form-item label-width="130px" prop="relevance">
                              <span slot="label">
                                  <span style="color: red">*</span>冲红原因：
                              </span>
                              <div>{{ getName(formData.hedgeReasonType,'开票冲红原因') }}</div>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item prop="upstreamInvoiceItem" label-width="130px">
                              <span slot="label">
                                  <span style="color: red">*</span>是否当月冲红：
                              </span>
                              <div>{{ formData.isCurrentMonthHedge=='Y'?'是':'否'}}</div>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item prop="upstreamInvoiceItem" label-width="130px">
                              <span slot="label">
                                  <span style="color: red">*</span>对方是否抵扣：
                              </span>
                              <div>{{ formData.isDeduct=='Y'?'是':'否'}}</div>
                          </el-form-item>
                      </el-col>
                  </el-row>
                 
                  <el-row :gutter="24">
                      <!-- <el-col :span="8">
                          <el-form-item label-width="130px" prop="relevance">
                              <span slot="label">
                                  <span style="color: red">*</span>业务类型：
                              </span>
                              <div>{{ getName(formData.businessCategory,'合同内容分类') }}</div>
                          </el-form-item>
                      </el-col> -->

                      <el-col :span="8">
                          <el-form-item label-width="131px" prop="relevance">
                              <span slot="label">
                                  <span style="color: red">*</span>抵扣联是否回收：
                              </span>
                              <div>{{ formData.isRetrieveDeduction=='Y'?'是':'否'}}</div>
                          </el-form-item>
                      </el-col>
                    
                      <el-col :span="8">
                          <el-form-item prop="upstreamInvoiceItem" label-width="130px">
                              <span slot="label">
                                  <span style="color: red">*</span>开票主体：
                              </span>
                              <div>{{ formData.invoiceTenantName}}</div>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item prop="upstreamInvoiceItem" label-width="130px">
                              <span slot="label">
                                  <span style="color: red">*</span>客户名称：
                              </span>
                              <div>{{ formData.paymentTenantName}}</div>
                          </el-form-item>
                      </el-col>
                  </el-row>

                  <el-row :gutter="24">
                      <el-col :span="8">
                          <el-form-item label-width="130px" prop="relevance">
                              <span slot="label">
                                  <span style="color: red">*</span>开票日期：
                              </span>
                              <div>{{ formData.invoiceDate|getDate }}</div>
                          </el-form-item>
                      </el-col>
                      <el-col :span="16">
                          <el-form-item prop="upstreamInvoiceItem" label-width="130px" style="width:600px;">
                              <span slot="label">
                                  <span style="color: red">*</span>冲红票据：
                              </span>
                              <div v-for="item in formData.hedgeDataInfoList" :key="item.guid">{{ item.name }}<span @click="seeRelateDetail(item)"
                                        class="file-preview">查看详情</span></div>
                          </el-form-item>
                      </el-col>
                  </el-row>
                  <el-row :gutter="24">
                      <el-col :span="24">
                          <el-form-item label-width="130px" prop="relevance">
                              <span slot="label">
                                  <span style="color: red">*</span>对冲说明：
                              </span>
                              <div>{{ formData.remarks }}</div>
                          </el-form-item>
                      </el-col>
                 
                  
                  </el-row>
              </el-form>
              <img
                  v-show="formData.bizApproveVO && formData.bizApproveVO.approveState !== 'N'"
                  class="approve-img"
                  :src="getApproveImg()"
                  alt=""
              />
          </div>
          <!-- end of 付款申请信息 -->

          <!-- start of 流程审批 -->
          <div class="back-color-fff mt-4">
              <!-- <span class="form-title">流程审批</span> -->
              <div class="flow">
                  <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
              </div>
          </div>
          <!-- end of 流程审批 -->
          <!-- start of bottom-btn -->
          <div class="back-color-fff submit_btn_wrap">
              <el-button type="defalut" class="cannel-btn" size="mini" @click="$router.go(-1)">取消</el-button>
              <el-button type="danger" size="mini" v-show="getBtnState('approval') == 'approval'"
                  @click="reject()">驳回</el-button>
              <el-button type="primary" size="mini" v-show="getBtnState('approval') == 'approval'"
                  @click="pass()">通过</el-button>
              <el-button type="primary" size="small" v-show="getBtnState('revoke') == 'revoke'"
                  @click="cancel()">撤销</el-button>
              <!-- <el-button type="primary" size="small" v-show="getBtnState('again') == 'again'" @click="reSubmit()">重新提交</el-button> -->
          </div>
          <!-- end of bottom-btn -->
      </div>
      <!-- end of form -->

      <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
          <el-input  style="margin:20px 0;" type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
          </el-input>
          <span slot="footer" class="dialog-footer">
              <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
          </span>
      </el-dialog>
      <PassDialog 
        ref="passDialogRef" 
        :showInvoiceDate="showInvoiceDate"
        @submit="toPassSubmit" 
      />

  </div>
</template>

<script>
import { bpmnroute } from '@/api/apiRoute';
import workFlowCommon from '@/uilt/workFlowCommon';
import PassDialog from './components/PassDialog.vue';
import store from '@/store';
import print from 'print-js';
export default {
  components: {
    PassDialog,
  },
  data() {
    return {
      fullscreenLoading: false,
      guid: '',
      formData: null,

      // 流程图相关
      iframeSh: false,
      iframeSrc: '',

      // 拒绝 通过
      rejectDialogVisible: false,
      approveSuggest: '',
      isLastNode: false,
      showInvoiceDate: false,
    };
  },
  created() {
    this.guid = this.$route.query.guid;
    this.getDetail();
    this.getLastNode();
  },
  watch: {},
  methods: {
    async getLastNode() {
      let userinfo = JSON.parse(localStorage.userInfo);
      const { bizApproveVO } = this.formData;
      console.log(1111,bizApproveVO);
      let query = {
        staffGuid: userinfo.staffGuid,
        deploymentId: bizApproveVO.camundaDeploymentId,
        processInstanceId: bizApproveVO.camundaInstanceId,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/is-my-last-node`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return false;
      }
      this.isLastNode = data.data || false;
      // 如果是最后一个节点，需要选择实际对冲日期
      this.showInvoiceDate = this.isLastNode;
    },
    getName(name, key) {
      if (!name) return '-';
      let list = this.getCodeListByKey(key);
      if (typeof name == 'object') {
        let newArr = [];
        name.forEach(item => {
          list.forEach(el => {
            if (el.value == item) {
              newArr.push(el.text);
            }
          })
        })
        return newArr.length ? newArr.join('、') : '-';

      } else {
        let lisArr = list.filter(item => item.value == name);
        return lisArr.length ? lisArr[0].text : '-';
      }
    },
    getApproveImg() {
      return workFlowCommon.getApproveImg(this.formData.bizApproveVO && this.formData.bizApproveVO.approveState);
    },
    //获取详情
    getDetail() {
      let str = this.$route.query.detail;
      let detail = JSON.parse(decodeURIComponent(str));
      this.formData = detail;
      this.getApprovalList();
    },
    /**
     * 获取操作按钮显隐
     * @param {*} btnType 
     */
    getBtnState(btnType) {
      let { bizApproveVO } = this.formData;
      let userinfo = JSON.parse(localStorage.userInfo);
      return workFlowCommon.getListBtnState(btnType, bizApproveVO.approveState, bizApproveVO.staffGuid, bizApproveVO.approveStaffGuids, userinfo.staffGuid, bizApproveVO.approveState);

    },
    /**
     * 驳回
     */
    reject() {
      this.rejectDialogVisible = true;
      this.approveSuggest = '';
    },
    /**
     * 通过
     */
    pass() {
      this.$refs.passDialogRef.open();
    },
    /**
     * 撤销
     */
    cancel() {
      let self = this;
      let { bizApproveVO } = this.formData;
      this.$confirm('撤销后,该流程将不再进行审核,确定这样操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let query = {
          guid: bizApproveVO.approveGuid,
          flowType: bizApproveVO.flowType,
          approveStaffGuid: bizApproveVO.staffGuid,
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success('撤销成功！');
            self.$router.go(-1);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
        });
      });
    },
    /**
     * 驳回提交
     */
    toRejectSubmit() {
      if (!this.approveSuggest) {
        return this.$message.error('请填写驳回理由')
      }
      let userInfo = JSON.parse(localStorage.userInfo);
      let { bizApproveVO } = this.formData;
      let query = {
        guid: bizApproveVO.approveGuid,
        flowType: bizApproveVO.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userInfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.approveSuggest = '';
          this.$message.success('驳回成功！');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 通过提交
     */
    toPassSubmit(data) {
      let userInfo = JSON.parse(localStorage.userInfo);
      let { bizApproveVO } = this.formData;
      let query = {
        ...data,
        guid: bizApproveVO.approveGuid,
        flowType: bizApproveVO.flowType,
        approveStaffGuid: userInfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$refs.passDialogRef.close();
          this.$message.success('审批通过！');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },

    /**
     * 查看对账单
     */
    see(url) {
      if (!url) {
        return;
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + url);
    },
    /**
     * 获取流程列表
     */
    getApprovalList() {
      // 00021:结算单流程,00022:付款单流程
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);

      let { bizApproveVO } = this.formData;

      if (this.guid && bizApproveVO.camundaInstanceId && bizApproveVO.camundaDeploymentId) {
        this.iframeSh = true;
        this.iframeSrc = bpmnroute + '/iframeBpmn?processInstanceId=' + bizApproveVO.camundaInstanceId + '&camundaDeploymentId=' + bizApproveVO.camundaDeploymentId + '&token=' + localStorage.token;
        return;
      }
      let req = {
        tenantGuid: localStorage.guid,
        flowType: '00029',
        staffGuid: userInfo.staffGuid,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.iframeSh = true;
              self.iframeSrc = bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
            } else {
              self.$message.error('未获取到流程信息');
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 数字金额转大写
     * @param {*} num 
     */
    convertToChinese(num) {
      const digits = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
      const decimals = ['角', '分'];
      const cnIntRadice = ['', '拾', '佰', '仟'];
      const cnIntUnits = ['', '万', '亿', '兆'];

      let cnNum = '';
      let isNegative = false;

      if (num < 0) {
        isNegative = true;
        num = Math.abs(num);
      }

      let parts = String(num).split('.');
      let integerPart = parts[0];
      let decimalPart = parts[1];

      if (Number(integerPart) === 0) {
        cnNum = digits[0];
        return cnNum;
      }

      let intLen = integerPart.length;
      let zeroCount = 0;

      for (let i = 0; i < intLen; i++) {
        let n = parseInt(integerPart.charAt(i));
        let p = intLen - i - 1;
        let q = p / 4;
        let m = p % 4;

        if (n === 0) {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            cnNum += digits[0];
          }
          zeroCount = 0;
          cnNum += digits[n] + cnIntRadice[m];
        }

        if (m === 0 && zeroCount < 4) {
          cnNum += cnIntUnits[q];
        }
      }

      if (decimalPart) {
        let decLen = decimalPart.length;
        for (let i = 0; i < decLen; i++) {
          let n = parseInt(decimalPart.charAt(i));
          if (n !== 0) {
            cnNum += digits[n] + decimals[i];
          }
        }
      }

      if (isNegative) {
        cnNum = '负' + cnNum;
      }

      return cnNum;
    },
    /**
   * 数字金额转大写
   * @param {*} num 
   */
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split(".");

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // 将整数部分和小数部分拼接起来
      return parts.join(".");
    },
    seeDetail() {
      let self = this;
      self.fullscreenLoading = true;
      self.api
        .get(
          `/${serverConfig.msSalesPerformService}/upstream/operation-report/detail?guid=${this.formData.hedgeSourceGuid}`,
        )
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data;
            console.log(data);
            this.$router.push({
              path: '/upstreamOperationReportDetail',
              query: {
                productGuid: this.$route.query.productGuid,
                guid: this.formData.hedgeSourceGuid,
                approveStaffGuid: data.approveVO.approveGuid,
                camundaInstanceId: data.approveVO.camundaInstanceId,
                camundaDeploymentId: data.approveVO.camundaDeploymentId,
                tenantGuid: data.tenantGuid,
                submitStaffGuid: data.approveVO.staffGuid,
                submitStaffName: data.approveVO.staffName,
                toType: 2,
              }
            })
          } else {
            self.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          self.fullscreenLoading = false;
        });

    },
    seeRelateDetail(item) {
      //预开票申请
      let path = 'upstreamAdvanceInvoiceDetail';
      let url = '/upstream/payment-plan-invoice-apply/detail?guid=' + item.guid;
      this.api.get(`/${serverConfig.msSalesPerformService}${url}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data;
          let query = {
            productGuid: this.$route.query.productGuid,
            guid: item.guid,
            approveStaffGuid: data.approveVO.approveGuid,
            camundaInstanceId: data.approveVO.camundaInstanceId,
            camundaDeploymentId: data.approveVO.camundaDeploymentId,
            tenantGuid: data.tenantGuid,
            submitStaffGuid: data.approveVO.staffGuid,
            submitStaffName: data.approveVO.staffName,
            toType: 2,
          }
          this.$router.push({
            path,
            query
          })

        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
  },
};
</script> 

<style lang="less" scoped>
.import-step-tip {
  text-align: left;
  font-size: 12px;
  line-height: 20px;
}

.file-operate {
  display: flex;
}

.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
  word-break: keep-all;
}

.content {
  padding: 0px;
  margin: 0px;

  .title-box {
      border-top: 1px solid #E5E5E5;
      background-color: #ffffff;
      padding: 8px 0px;
      position: relative;

      button {
          font-size: 12px;
          color: #212121;
          letter-spacing: 0;
          width: 60px;
          height: 26px;
          padding: 0px;
          border: 1px solid rgba(217, 217, 217, 1);
          border-radius: 2px;
          position: absolute;
          left: 16px;
          top: 6px;
      }

      span {
          text-align: center;
          font-size: 16px;
          font-weight: 400;
      }
  }

  .mt-4 {
      margin-top: 4px;
      padding-bottom: 10px;
  }

  .form-box {
      margin-top: 4px;
      text-align: left;
      position: relative;

      .form-title {
          height: 40px;
          line-height: 40px;
          font-size: 16px;
          margin-left: 16px;
          font-weight: 500;
      }

      /deep/ .el-row {
          margin: 0px !important;
      }

      .el-form-item {
          margin-bottom: 0px;
      }

      .over-label /deep/ .el-form-item__label {
          line-height: 21px;
      }

      .el-input {
          width: 220px;
      }

      .bottom-btn-box {
          padding: 18px 0px;
          text-align: center;
          border-top: 1px solid #E5E5E5;

          .el-button--primary {
              color: #ffffff;
          }
      }
  }

  /deep/ .el-dialog__header {
      text-align: left;
      border-bottom: 1px solid #D9D9D9;
  }

  /deep/ .el-dialog__body {
      padding: 0px 20px;
  }

  /deep/ .el-dialog__footer {
      padding: 10px 20px;
      border-top: 1px solid #D9D9D9;
  }


  .flow {
      background: #fff;
      padding-left: 20px;
  }

  .iframe-sty {
      width: 100%;
      border: none;
      height: 600px;

  }

  .detail-box {
      height: auto;
      border: 1px solid rgba(217, 217, 217, 1);
      margin: 0px 16px;
      padding: 16px 16px 100px 16px;
  }

  .cannel-btn {
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      color: #212121;
  }

  .content-main-box2 {
      height: 55vh;
      overflow-x: hidden;

      .search-area {
          padding: 16px 0px;
      }

      .el-table {
          border-left: 1px solid #D8D8D8;
          border-right: 1px solid #D8D8D8;
          border-bottom: 1px solid #D8D8D8;
      }
  }

  .file-img-box {
      display: flex;
      align-items: center;

      img {
          width: 26px;
          height: 26px;
          margin-right: 10px;
      }

      .see-btn {
          font-size: 14px;
          color: #4FA1A4;
          letter-spacing: 0;
          line-height: 21px;
          font-weight: 400;
          cursor: pointer;
          margin-left: 10px;
      }
  }

  .flex-between,
  .form-title-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
  }

  .form-title-box {
      padding-right: 16px;
  }

  h2 {
      text-align: center;
  }

  .txt-right {
      text-align: right;

      span {
          margin: 0px 16px;
      }
  }

  .table1 {
      border: 1px solid rgba(229, 229, 229, 1);

      .header-div {
          background: #F2F2F2;
          font-size: 12px;
          color: #909399;
          letter-spacing: 0;
          text-align: center;
          font-weight: bold;
          height: 32px;
          line-height: 32px;
          border: 1px solid rgba(229, 229, 229, 1);
      }

      .tab-label {
          padding: 0px 10px;
          width: 280px;
          height: 32px;
          color: #212121;
          line-height: 32px;
          background: #FAFAFA;
          border-bottom: 1px solid rgba(229, 229, 229, 1);
          border-right: 1px solid rgba(229, 229, 229, 1);
          border-left: 1px solid rgba(229, 229, 229, 1);
      }

      .tab-value {
          text-align: right;
          padding: 0px 10px;
          width: calc(100% - 320px);
          height: 32px;
          line-height: 32px;
          border-bottom: 1px solid rgba(229, 229, 229, 1);
          border-right: 1px solid rgba(229, 229, 229, 1);
          color: #666666;
      }

      p {
          color: #666666;
      }

      .line-box {
          height: 32px;
          line-height: 32px;
          border-bottom: 1px solid rgba(229, 229, 229, 1);
          padding-left: 10px;

          div:first-child {

              width: 80px;
              background: #FAFAFA;
              // border-top: 1px solid rgba(229, 229, 229, 1);
              border-right: 1px solid rgba(229, 229, 229, 1);
              font-weight: bold;
          }

          div:last-child {
              padding: 10px 6px;
              width: calc(100% - 80px);

              // border-top: 1px solid rgba(229, 229, 229, 1);
          }
      }
  }

  .table2,
  .table3 {
      width: 100%;

      td {
          padding: 6px;
          border: 1px solid rgba(229, 229, 229, 1);
          border-right: 0 none;
          border-top: 0 none;
      }

      th {
          border: 1px solid rgba(229, 229, 229, 1);
          border-right: 0 none;
          background: #F2F2F2;
          padding: 6px;
      }

      td:last-child {
          border-right: 1px solid rgba(229, 229, 229, 1);

      }

  }

  .table2 {
      margin: 16px 0px;
  }

  .info-box {
      width: 390px;
  }
}

.wth800 {
  width: 800px;
}
.approve-img {
position: absolute;
top: 10px;
right: 40px;
width: 78px;
height: 78px;
z-index: 999;
}
</style>
